<div class="content space-y-4">
    <div class="flex justify-between items-center">
        <div class="flex items-center gap-2 text-lg font-semibold text-primary-500">
            <fa-icon [icon]="faReceipt" class="text-primary-500 text-xl"></fa-icon>
            <span>ใบรับเข้า</span>
            <span class="label label-primary !text-xs">สาขา</span>
        </div>
    </div>

    <div class="card">
        <div class="space-y-4">
            <div class="w-full">
                <label class="text-sm">ช่วงเวลาข้อมูล</label>
                <app-select-date-option [selectedOption]="selectedDate"
                    (selectOption)="onDateOptionSelected($event)"></app-select-date-option>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div class="w-full md:col-span-2">
                    <label class="text-sm">สาขา</label>
                    <mat-form-field class="w-full">
                        <mat-select multiple [value]="displayedChannelSelection"
                            (selectionChange)="onChannelSelectionChange($event.value)"
                            placeholder="เลือกสาขา">
                            <mat-option [value]="ALL_CHANNEL_MARKER">เลือกทั้งหมด</mat-option>
                            @for (branch of channels; track $index) {
                            <mat-option [value]="branch.shop_ref">
                                {{ branch.platform_name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    @if (loading) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">Loading</div>
        </div>
    </div>
    } @else if (errorMessage) {
    <div class="card">
        <div class="text-sm text-red-500 py-4 text-center">{{ errorMessage }}</div>
    </div>
    } @else if (rows.length === 0) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <div class="h-32">
                <img src="assets/images/web_20.png" alt="" class="h-full">
            </div>
            <div class="font-medium text-gray-600">ไม่มีใบรับเข้า</div>
        </div>
    </div>
    } @else {
    <div class="card">
        <div>
            <div class="div-table">
                <table>
                    <thead>
                        <tr class="thead-tr divide-x">
                            <th class="text-left">เลขที่คำสั่งซื้อ</th>
                            <th class="text-left">สาขา</th>
                            <th class="text-left">วันที่สั่ง</th>
                            <th class="text-left">วันที่โยกคลัง</th>
                            <th class="text-left">วันที่รับเข้า</th>
                            <th class="text-center">จำนวนสินค้า</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of rows; track $index) {
                        <tr class="tbody-tr divide-x hover:bg-primary-50 cursor-pointer" (click)="openDetail(row)">
                            <td>
                                <span class="font-mono font-semibold text-primary-600">{{ row.order_no }}</span>
                            </td>
                            <td>
                                <span class="truncate">{{ row.branch_name || '-' }}</span>
                            </td>
                            <td>{{ row.order_date }}</td>
                            <td [ngClass]="{'text-red-500': !row.pack_date}">
                                {{ row.pack_date || 'ยังไม่ได้แพ็ค' }}
                            </td>
                            <td [ngClass]="{'text-red-500': row.pack_date && !row.receive_date}">
                                @if (row.receive_date) {
                                {{ row.receive_date }}
                                } @else if (row.pack_date) {
                                ยังไม่ได้รับเข้า
                                } @else {
                                -
                                }
                            </td>
                            <td class="text-center">
                                {{ row.qty != null ? (row.qty | number) : '-' }}
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            <app-pagination [callBackPageChange]="callBackPageChange" [pageSize]="pageSize" [pageIndex]="pageIndex"
                [length]="countDataSource"></app-pagination>
        </div>
    </div>
    }
</div>